import { KEYS, matchKey } from "@excalidraw/common";

import { CaptureUpdateAction } from "@excalidraw/element";

import { register } from "./register";

export const actionToggleMindMapMode = register({
  name: "mindMapMode",
  label: "labels.toggleMindMap",
  viewMode: false,
  trackEvent: {
    category: "canvas",
    predicate: (appState) => !appState.mindMapModeEnabled,
  },
  perform(elements, appState) {
    return {
      appState: {
        ...appState,
        mindMapModeEnabled: !this.checked!(appState),
      },
      captureUpdate: CaptureUpdateAction.EVENTUALLY,
    };
  },
  checked: (appState) => appState.mindMapModeEnabled,
  keyTest: (event) =>
    !event[KEYS.CTRL_OR_CMD] && event.altKey && matchKey(event, KEYS.M),
});
